export enum matomeDetailTypes {
  FETCH_MATOME_DETAIL_REQUEST = "FETCH_MATOME_DETAIL_REQUEST",
  FETCH_MATOME_DETAIL_SUCCESS = "FETCH_MATOME_DETAIL_SUCCESS",
  FETCH_MATOME_DETAIL_FAILURE = "FETCH_MATOME_DETAIL_FAILURE",
}